// adapted from sha512-universal library: https://github.com/chm-diederichs/sha512-universal
import js from './sha512-js';
import wasm from './sha512-wasm';
import { logger } from '../../logger';

const log = logger('Encryption');

let Proto = js;

export const WASM_SUPPORTED = wasm.SUPPORTED;
export let WASM_LOADED = false;
export const SHA512_BYTES = 64;

export function sha512() {
  return new Proto();
}

wasm.ready(err => {
  if (Proto !== wasm && !err) {
    Proto = wasm;
    WASM_LOADED = true;
    log.info('SHA512 PROTO set to WASM');
  }
});
